export const NAV = {
    HOME: "home",
    SHOW_PERSON: "showPerson",
    CONTACT: "contact",
    MEDICAL: "medical",
    EMERGENCY: "emergency",
    GROUPS: "groups",
    TOURS: "tours",
    SETTINGS: "settings",
    ACCOUNT: "account",
    PROFILE: "profile",
    MEMBERSHIPS: "memberships",
} as const;

// Automatisch generierte Routen
export const ROUTES = Object.fromEntries(
    Object.entries(NAV).map(([key, value]) => [key, "/" + value])
) as Record<keyof typeof NAV, string>;